import React, { useState, useEffect } from 'react'
import "../../assets/style/eegisterProvider.css"
import { TextField, Button, Typography, Box } from '@mui/material';
import FundProviderTable from '../../components/Table/FundProviderTable';
import ApiCall from '../../utils/Api';
import { toast } from 'react-toastify';

const FundProvider = () => {
  const [BackDropState, setBackDropState] = useState(false);
  const [fundProviders, setFundProviders] = useState([]);
  const [filteredProviders, setFilteredProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchAddress, setSearchAddress] = useState('');

  // Get all fund providers
  const fetchFundProviders = async () => {
    try {
      setLoading(true);
      setBackDropState(true);
      
      // Fetch all providers from admin endpoint
      const response = await ApiCall.SECURE_API.get('/admin/getAllProviders');
      
      if (response.data.success) {
        const providers = response.data.data || [];
        console.log('🚀 Fund Providers fetched:', providers);
        setFundProviders(providers);
        setFilteredProviders(providers);
        toast.success(`Loaded ${providers.length} fund providers`);
      } else {
        toast.error(response.data.message || 'Failed to load fund providers');
      }
    } catch (error) {
      console.error('Error fetching fund providers:', error);
      toast.error('Failed to load fund providers');
    } finally {
      setLoading(false);
      setBackDropState(false);
    }
  };

  // Filter providers based on search
  const applySearch = () => {
    if (!searchAddress.trim()) {
      setFilteredProviders(fundProviders);
      return;
    }

    const filtered = fundProviders.filter(provider => {
      // Search in wallet addresses array
      if (provider.walletAddress && Array.isArray(provider.walletAddress)) {
        return provider.walletAddress.some(address => 
          address.toLowerCase().includes(searchAddress.toLowerCase())
        );
      }
      // Fallback to single wallet address
      return provider.walletAddress && 
        provider.walletAddress.toLowerCase().includes(searchAddress.toLowerCase());
    });
    setFilteredProviders(filtered);
  };

  // Clear search
  const clearSearch = () => {
    setSearchAddress('');
    setFilteredProviders(fundProviders);
  };

  useEffect(() => {
    fetchFundProviders();
  }, []);

  useEffect(() => {
    applySearch();
  }, [searchAddress, fundProviders]);

  return (
    <div style={{ 
      width: '100%', 
      minHeight: '100vh', 
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <div style={{ 
        maxWidth: '1400px', 
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom
          sx={{ 
            fontSize: '28px',
            fontWeight: '600',
            color: '#333',
            marginBottom: '24px'
          }}
        >
          Fund Provider
        </Typography>
        
        {/* Search Section */}
        <Box sx={{ 
          display: 'flex', 
          gap: 2, 
          mb: 4, 
          alignItems: 'center',
          padding: '16px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #e9ecef'
        }}>
          <TextField
            label="Provider Address"
            placeholder="Search Provider"
            value={searchAddress}
            onChange={(e) => setSearchAddress(e.target.value)}
            sx={{ 
              minWidth: '300px',
              backgroundColor: 'white'
            }}
            variant="outlined"
            size="small"
          />
          
          <Button 
            variant="outlined" 
            onClick={clearSearch}
            sx={{ 
              height: '40px',
              minWidth: '100px',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Clear
          </Button>
        </Box>

        {/* Fund Provider Table */}
        <FundProviderTable 
          data={filteredProviders}
          loading={loading}
          onRefresh={fetchFundProviders}
        />

        {/* Loading Backdrop */}
        {BackDropState && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <div style={{ color: 'white', fontSize: '18px' }}>Loading...</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FundProvider;
